import { Component, OnInit } from '@angular/core';

import { FormField } from '@models/forms/form-field.model';
import { FormFieldBooleanComponent } from '../form-field-boolean/form-field-boolean.component';
import { FormFieldCheckboxComponent } from '../form-field-checkbox/form-field-checkbox.component';
import { FormFieldComponent } from '../form-field/form-field.component';
import { FormFieldDateComponent } from '../form-field-date/form-field-date.component';
import { FormFieldDefaultComponent } from '../form-field-default/form-field-default.component';
import { FormFieldGroup } from '@models/forms/form-field-group.model';
import { FormFieldMultiselectComponent } from '../form-field-multiselect/form-field-multiselect.component';
import { FormFieldTextComponent } from '../form-field-text/form-field-text.component';
import { FormFieldTextareaComponent } from '../form-field-textarea/form-field-textarea.component';
import { FormFieldTimeComponent } from '../form-field-time/form-field-time.component';
import { FormFileComponent } from '../form-file/form-file.component';
import { FormQuestion } from '@models/forms/form-question.model';
import { FormsDirective } from '../../../directives/forms.directive';
import { QuestionType } from '@models/forms/form-question.model';
import { ViewChild } from '@angular/core';
import { ViewContainerRef } from '@angular/core';
import { forEach } from 'lodash';

@Component({
  selector: 'app-form-group',
  templateUrl: './form-group.component.html',
  styleUrls: ['../../../mig-form.component.scss'],
})
export class FormGroupComponent implements OnInit {
  @ViewChild(FormsDirective, { static: true })
  private directive!: FormsDirective;
  private container!: ViewContainerRef;
  group!: FormFieldGroup;
  section: FormField;
  fields: any[] = [];

  ngOnInit(): void {
    this.container = this.directive.viewContainerRef;
    this.container.clear();
    forEach(this.group.questions, question => {
      const component = this.container.createComponent<FormFieldComponent>(
        this.getComponent(question)
      );
      component.instance.section = this.section;
      component.instance.group = this.group;
      component.instance.question = question;
      this.fields.push(component);
    });
  }

  private getComponent(question: FormQuestion) {
    switch (question.questionType) {
      case QuestionType.Boolean:
        return FormFieldBooleanComponent;
      case QuestionType.Checkbox:
        return FormFieldCheckboxComponent;
      case QuestionType.Date:
        return FormFieldDateComponent;
      case QuestionType.Multiselect:
        return FormFieldMultiselectComponent;
      case QuestionType.Text:
        return FormFieldTextComponent;
      case QuestionType.Textarea:
        return FormFieldTextareaComponent;
      case QuestionType.File:
        return FormFileComponent;
      case QuestionType.Time:
        return FormFieldTimeComponent;
    }
    return FormFieldDefaultComponent;
  }
}
